import { IApiToken } from '../types/IApiToken';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class DeleteApiTokenRequest extends Request<Object, any> {
  constructor(tokenId: string) {
    super('deleteApiToken', {'apiToken' : <IApiToken>{'id' : tokenId}});
  }
}
